import { Component } from '@angular/core';
import { ProgressBar } from 'primeng/progressbar';
import { Card } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { Accordion, AccordionTab } from 'primeng/accordion';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'patient-summury-details',
  imports: [ProgressBar, Card, CommonModule, Accordion, AccordionTab, ChartModule],
  templateUrl: './summury-details.component.html',
  styleUrl: './summury-details.component.css',
})
export class SummuryDetailsComponent {
  dietData: any;
  chartData: any;

  ngOnInit() {
    const state = history.state;
    console.log(state, 'state indetails ');

    if (state?.document) {
      this.dietData = state.document;

      console.log('Assessment object:', this.dietData);

      // 🔑 parse JSON string
      if (this.dietData.jsonData) {
        this.dietData = JSON.parse(this.dietData.jsonData);
      }

      const n = this.dietData.diet_plan.nutrition_summary;

      this.chartData = {
        labels: ['Protein', 'Carbs', 'Fats'],
        datasets: [
          {
            data: [n.protein_g, n.carbs_g, n.fats_g],
          },
        ],
      };

      console.log('Parsed Diet Data:', this.dietData);
    }
  }
}
